<template>
  <div
  id="direct-payments-sendbox"
  class="page page-on-center close-picker"
  data-page="sendbox-page">

  <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
    <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank" @click="openCreateRequest">
      <f7-icon f7="add"></f7-icon>
    </f7-fab>
    <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractSentDirectPaymentsCSV(inboxMessages)" v-if="currentTAB === 'sent'">
      <f7-icon f7="document_text"></f7-icon>
    </f7-fab>
    <f7-fab class="leftfav3 button-fab bottomButton floatingButtonToolbarBlank" @click="onRefreshSentDirectPayments()" v-if="currentTAB === 'sent'">
      <f7-icon f7="refresh"></f7-icon>
    </f7-fab>
    <f7-fab class="leftfav4 button-fab bottomButton floatingButtonToolbarBlank" href="/directPayments/sendbox/import/payment" v-if="currentTAB === 'sent' && isAdmin">
      <f7-icon f7="list_bullet"></f7-icon>
    </f7-fab>
    <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractDraftsCSV()" v-if="currentTAB === 'draft'">
      <f7-icon f7="document_text"></f7-icon>
    </f7-fab>
    <f7-fab class="leftfav3 button-fab bottomButton floatingButtonToolbarBlank" @click="onRefreshDrafts()" v-if="currentTAB === 'draft'">
      <f7-icon f7="refresh"></f7-icon>
    </f7-fab>
    <f7-fab class="leftfav4 button-fab bottomButton floatingButtonToolbarBlank" href="/directPayments/sendbox/import/draft" v-if="currentTAB === 'draft'">
      <f7-icon f7="list_bullet"></f7-icon>
    </f7-fab>
  </div>

     <div class="page-content filterHeight heightifLargeScreen"
          style="z-index:9;">

    <page-nav-bar
      v-bind:currentServiceName="serviceName"
      popoverName=""
      subNavTitle="Sent Direct Payments List">
    </page-nav-bar>

    <div class="row rowBackgroundImage" v-bind:class="colorBottomButton">
      <div class="row showLargeScreenOnly rowSearchBar">
        <div class="firstButtonMarginLeft showLargeScreenOnly">
          <button class="new-button milkyBlock boxRequest" @click="openCreateRequest">
            <f7-icon f7="add"></f7-icon>
            <span>Create Direct Payment</span>
          </button>
          <button class="milkyBlock new-button boxRequest" @click="extractSentDirectPaymentsCSV()" v-if="currentTAB === 'sent'">
            <f7-icon f7="document_text"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Extract CSV</span>
          </button>
          <button class="milkyBlock new-button boxRequest" @click="onRefreshSentDirectPayments()" v-if="currentTAB === 'sent'">
            <f7-icon f7="refresh"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Refresh</span>
          </button>
          <button class="milkyBlock new-button boxRequest" @click="$f7.mainView.router.load({url: '/directPayments/sendbox/import/payment'})"  v-if="currentTAB === 'sent' && isAdmin">
            <f7-icon f7="list_bullet"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Import</span>
          </button>
          <button class="milkyBlock new-button boxRequest" @click="extractDraftsCSV()" v-if="currentTAB === 'draft'">
            <f7-icon f7="document_text"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Extract CSV</span>
          </button>
          <button class="milkyBlock new-button boxRequest" @click="onRefreshDrafts()" v-if="currentTAB === 'draft'">
            <f7-icon f7="refresh"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Refresh</span>
          </button>
          <button class="milkyBlock new-button boxRequest" @click="$f7.mainView.router.load({url: '/directPayments/sendbox/import/draft'})"  v-if="currentTAB === 'draft'">
            <f7-icon f7="list_bullet"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Import</span>
          </button>
        </div>
      </div>
    </div>

    <div class="row search">
      <div class="col-md-12">
        <div class="contactButtonContainer">
          <f7-grid no-gutter>
            <f7-col width="50" class="pilotageTabController">
              <f7-link class='pilotageLink' v-bind:class="{tabActive: currentTAB === 'sent'}" tab-link="#sentDPtab" @click="changeActiveTab('sent')" :tab-link-active="currentTAB === 'sent'">Sent</f7-link>
            </f7-col>
            <f7-col width="50" class="pilotageTabController">
              <f7-link class='pilotageLink' v-bind:class="{tabActive: currentTAB === 'draft'}" tab-link="#draftDPtab" @click="changeActiveTab('draft')" :tab-link-active="currentTAB === 'draft'">In Progress</f7-link>
            </f7-col>
          </f7-grid>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <f7-tabs>
          <f7-tab id="sentDPtab" ref="sentDPtabTab" tab-active>
            <sent-dp ref="sentdp"></sent-dp>
          </f7-tab>
          <f7-tab id="draftDPtab" ref="draftDPtabTab" tab-active>
            <dp-drafts ref="refdrafts"></dp-drafts>
          </f7-tab>
        </f7-tabs>
      </div>
    </div>

    <div class="toolbarPageBottomBlank"></div>

    </div>
  </div>
</div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import SentDP from './sendbox/SentDP.vue'
import Drafts from './sendbox/Drafts.vue'
// import $ from 'jquery'

export default {
  name: 'Sentbox',
  components: {
    'page-nav-bar': pageNavBar,
    'sent-dp': SentDP,
    'dp-drafts': Drafts
  },
  props: ['tab'],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      serviceName: 'MoneyRoad',
      sendboxDir: 1,
      noMoreMessages: false,
      newRequest: 1,
      scrollDown: false,
      noMore: false,
      afterBack: false,
      currentTAB: '',
      clearance: '',
      accountType: ''
    }
  },
  created () {
    this.clearance = this.$engine.user.get().clearance['Direct Payments']
    this.accountType = this.$engine.user.get().type
  },
  mounted () {
    if ((typeof this.tab) !== 'undefined' && this.tab === 'draft') {
      this.currentTAB = 'draft'
      this.$refs.draftDPtabTab.show()
    } else {
      this.currentTAB = 'sent'
      this.$refs.sentDPtabTab.show()
    }
  },
  beforeDestroy () {
    let that = this
    this.$f7.onPageAfterBack('details-page', function (page) {}).remove()
    that.$engine.services.directPayments.filter.cleanFilterCondition()
  },
  computed: {
    isAdmin: function () {
      return this.accountType === '2' || (this.accountType === '1' && this.clearance === '1')
    }
  },
  methods: {
    // Sent DP methods
    extractSentDirectPaymentsCSV () {
      this.$refs.sentdp.extractCSV()
    },
    onRefreshSentDirectPayments: function (index = 1) {
      this.$refs.sentdp.onRefresh(index)
    },
    // Drafts methods
    extractDraftsCSV () {
      this.$refs.refdrafts.extractCSV()
    },
    onRefreshDrafts () {
      this.$refs.refdrafts.refreshDrafts()
    },
    // Common methods
    openCreateRequest () {
      // Common because also used to create drafts
      this.$refs.sentdp.openCreateRequest()
    },
    changeActiveTab (value) {
      this.currentTAB = value
    }
  }
}
</script>

<style scoped>
  .tabActive {
    background-color: #12bcf1;
    color: white;
  }
  .new-button.pull-right {
    width: 125px;
    margin-right: 0px;
  }
  @media (max-width: 768px) {
    .toolbarPageBottomBlank {
      height: 75px !important;
    }
  }
  @media (min-width: 993px) {
    .searchForm {
      margin-top: 0%;
    }
    .heightifLargeScreen {
      overflow-y: auto;
      height: 105%;
    }
    .contactButtonContainer {
      margin-top: 0% !important;
      margin-left:0px
    }
  }

.rowBackgroundImage {
  background-image: url('../../../assets/static/images/MenuFont.png');
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// SendboxPage.vue?96043a02